import dio, { DioContext, DioType } from './init';

export default {
  clickAddonIcon: () =>
    dio.track(
      'click_addon_icon',
      DioType.CLICK,
      { location: window.location.href },
      DioContext.DYNAMIC_PRICING
    ),
  clickDptOption: () =>
    dio.track(
      'click_dpt_option',
      DioType.CLICK,
      {},
      DioContext.DYNAMIC_PRICING
    ),
  clickDpOption: () =>
    dio.track('click_dp_option', DioType.CLICK, {}, DioContext.DYNAMIC_PRICING),
};
